import TouchableOpacity from '../common/TouchableOpacity'
import Text from '../common/Text'
import { useScreenShare } from '../provider/screenShare'
import styles from './style'

function ShareScreenButton() {
  const { mySharedId, canShare, startSharing, stopSharing } = useScreenShare()
  const isSharing = mySharedId !== null

  if (!canShare) return null

  return (
      <TouchableOpacity
        style={{ ...styles.shareButton, ...(isSharing ? styles.shareButtonActive : {}) }}
        disabled={!canShare}
        onClick={() => {
          if (isSharing) {
            stopSharing()
          } else {
            // Rejected/cancelled picker — nothing to clean up, just no-op.
            startSharing().catch(() => {})
          }
        }}
      >
        <Text>
          {isSharing ? 'Stop sharing' : 'Share screen'}
        </Text>
      </TouchableOpacity>
    )
}

export default ShareScreenButton
